import { render } from "./ContactPersonsTable.vue?vue&type=template&id=22f23780"
import script from "./ContactPersonsTable.vue?vue&type=script&lang=ts"
export * from "./ContactPersonsTable.vue?vue&type=script&lang=ts"
script.render = render

export default script